import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./WorkspaceView.module.scss";
import { WorkspaceDetailsRow } from "./workspaceViewConfig";

export const NameCell = ({
    renderValue,
    row,
}: CellContext<ViewTableFeatures, WorkspaceDetailsRow, string>) => {
    const { getCopyProps } = useIdCopy({ label: "Workspace" });

    return (
        <span className={styles.nameValue} {...getCopyProps(row.original.id)}>
            {renderValue()}
        </span>
    );
};
